import './App.scss'

import { DataProvider } from './contexts/Data'
import { LoadingProvider } from './contexts/Loading'
import { FormProvider } from './contexts/Form'
import { UserProvider } from './contexts/User'
import { BrowserRouter } from 'react-router'
import { ModalProvider } from './contexts/Modal'
import { ToasterProvider } from './contexts/Toaster'
import { CharactersProvider } from './contexts/Characters'
import { ReadyProvider } from './contexts/Ready'
import { registerLocale } from  'react-datepicker'
import { enGB } from 'date-fns/locale'
import { useEffect } from 'react'
import AppLayout from './AppLayout'
import AppRoutes from './AppRoutes'

const { version } = require('../package.json')

registerLocale('en-GB', enGB)

function App() {

  useEffect(() => {
    console.log(`Koalition version ${version}`)
  }, [])

  return (
    <ToasterProvider>
      <DataProvider>
        <UserProvider>
          <LoadingProvider>
            <ReadyProvider>
                <BrowserRouter>
                  <ModalProvider>
                    <FormProvider>
                      <CharactersProvider>
                        <AppLayout>
                          <AppRoutes />
                        </AppLayout>
                      </CharactersProvider>
                    </FormProvider>
                  </ModalProvider>
                </BrowserRouter>
            </ReadyProvider>
          </LoadingProvider>
        </UserProvider>
      </DataProvider>    
    </ToasterProvider>
  )
}

export default App
